const ACCESS_RULES = {
  dashboards: {
    view: true,
    edit: true,
    publish: true,
    export: true,
    import: true,
  },
  cli: {
    connect: true,
    log: true,
  },
  srm: {
    view: true,
    edit: true,
    ci: { export: true, import: true },
    cit: { export: true, import: true },
    tql: { edit: true },
    modelling: {
      view: true,
      edit: true,
      enrichmentPlans: { view: true, edit: true },
      enrichmentProcesses: { view: true },
      citSections: {
        cit: { view: true },
        attributes: { view: true },
        links: { view: true },
        naming: { view: true },
        identification: { view: true },
        deletePolicy: { view: true },
        createCI: { view: true },
      },
    },
    enrichment: {
      export: true,
      import: true,
    },
    external: {
      endpoints: true,
      routes: {
        get: true,
      },
    },
  },
  monitoring: {
    vmagents: {
      export: true,
      import: true,
    },
    vmalerts: {
      export: true,
      import: true,
    },
    hi: {
      edit: true,
      export: true,
      import: true,
    },
    templates: {
      edit: true,
      export: true,
      import: true,
    },
    prometheus: {
      edit: true,
      jobs: {
        export: true,
        import: true,
      },
      exporters: {
        export: true,
        import: true,
      },
    },
    export: {
      edit: true,
    },
    import: {
      edit: true,
    },
  },
  users: {
    attribute: {
      edit: true,
    },
    change_password: {
      edit: true,
    },
    status: {
      edit: true,
    },
    profile: {
      view: true,
      edit: true,
    },
    ldap: {
      edit: true,
    },
    oidc: {
      edit: true,
    },
    delete: {
      edit: true,
    },
    api_token: {
      edit: true,
    },
    activity: {
      log: {
        view: true,
      },
    },
    session: {
      kill: true,
    },
  },
  access: {
    srm: { edit: true },
    monitoring: { edit: true },
    dashboards: { edit: true },
    func: { edit: true },
    tql: { edit: true },
  },
  notifications: {
    self: {
      edit: true,
    },
    external: {
      edit: true,
    },
    template: {
      edit: true,
    },
    alertmanager: {
      edit: true,
    },
  },
  system: {
    contentpack: {
      import: true,
      create: true,
    },
    docker: {
      edit: true,
      view: true,
      run: true,
    },
    plugins: {
      edit: true,
    },
    settings: {
      // edit: true,
      auth: { edit: true, view: true },
      srm: { edit: true, view: true },
      monitoring: { edit: true, view: true },
      notification: { edit: true, view: true },
      'docker-tool': { edit: true, view: true },
      'task-tool': { edit: true, view: true },
    },
    debug: {
      edit: true,
    },
  },
  license: {
    edit: true,
  },
  third_party_service: {
    os_dashboards: {
      edit: true,
    },
    flower: {
      edit: true,
    },
    alertmanager: {
      edit: true,
    },
    rabbitmq: {
      edit: true,
    },
    'metrics-agent': {
      edit: true,
    },
    'metrics-storage': {
      edit: true,
    },
    'metrics-ruler': {
      edit: true,
    },
  },
};
type WrapWithProxy<T> = {
  [K in keyof T]: T[K] extends object
    ? WrapWithProxy<T[K]> // Recursively wrap nested objects
    : string; // Replace leaf nodes with strings
};

function wrapWithProxy<T extends Record<string, any>>(
  obj: T,
  path = '',
): WrapWithProxy<T> {
  return new Proxy(obj, {
    get(target, prop: string) {
      const newPath = path ? `${path}.${prop}` : prop;
      if (typeof target[prop] === 'object' && target[prop] !== null) {
        return wrapWithProxy(target[prop], newPath);
      }

      const parts = newPath.split('.');
      parts[parts.length - 1] = '@' + parts[parts.length - 1];
      return parts.join('.');
    },
  });
}

export const ACCESS_RULES_TREE = wrapWithProxy(ACCESS_RULES);
export const DISABLED_RULE = 'disabled.rule';

export const RULES_TREE = [
  {
    key: 'dashboards',
    title: 'dashboards.label',
    children: [
      {
        key: ACCESS_RULES_TREE.dashboards.view,
        title: 'dashboards.view',
        default: true,
      },
      {
        key: ACCESS_RULES_TREE.dashboards.edit,
        title: 'dashboards.edit',
      },
      {
        key: ACCESS_RULES_TREE.dashboards.publish,
        title: 'dashboards.publish',
      },
      {
        key: ACCESS_RULES_TREE.dashboards.export,
        title: 'dashboards.export',
      },
      {
        key: ACCESS_RULES_TREE.dashboards.import,
        title: 'dashboards.import',
      },
    ],
  },
  /* {
    key: 'cli',
    title: 'cli.label',
    children: [
      {
        key: ACCESS_RULES_TREE.cli.connect,
        title: 'cli.connection',
        default: true,
      },
      {
        key: ACCESS_RULES_TREE.cli.log,
        title: 'cli.logs',
      },
    ],
  }, */
  {
    key: 'srm',
    title: 'srm.label',
    children: [
      {
        key: ACCESS_RULES_TREE.srm.view,
        title: 'srm.view',
        default: true,
      },
      {
        key: ACCESS_RULES_TREE.srm.external.endpoints,
        title: 'API',
      },
      {
        key: ACCESS_RULES_TREE.srm.edit,
        title: 'srm.edit',
      },
      {
        key: ACCESS_RULES_TREE.srm.tql.edit,
        title: 'srm.tql.edit',
      },
      {
        key: 'srm.modelling',
        title: 'srm.modelling.label',
        children: [
          {
            key: ACCESS_RULES_TREE.srm.modelling.view,
            title: 'srm.modelling.view',
          },
          {
            key: ACCESS_RULES_TREE.srm.modelling.edit,
            title: 'srm.modelling.edit',
          },
          {
            key: 'srm.modelling.enrichmentPlans',
            title: 'srm.modelling.enrichmentPlans.label',
            children: [
              {
                key: ACCESS_RULES_TREE.srm.modelling.enrichmentPlans.view,
                title: 'srm.modelling.enrichmentPlans.view',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.enrichmentPlans.edit,
                title: 'srm.modelling.enrichmentPlans.edit',
              },
            ],
          },
          {
            key: 'srm.modelling.enrichmentProcesses',
            title: 'srm.modelling.enrichmentProcesses.label',
            children: [
              {
                key: ACCESS_RULES_TREE.srm.modelling.enrichmentProcesses.view,
                title: 'srm.modelling.enrichmentProcesses.view',
              },
            ],
          },
          {
            key: 'srm.modelling.citSections',
            title: 'srm.modelling.citSections.title',
            children: [
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.cit.view,
                title: 'srm.modelling.citSections.cit',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.attributes
                  .view,
                title: 'srm.modelling.citSections.attributes',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.links.view,
                title: 'srm.modelling.citSections.links',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.naming.view,
                title: 'srm.modelling.citSections.naming',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.identification
                  .view,
                title: 'srm.modelling.citSections.identification',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.deletePolicy
                  .view,
                title: 'srm.modelling.citSections.deletePolicy',
              },
              {
                key: ACCESS_RULES_TREE.srm.modelling.citSections.createCI.view,
                title: 'srm.modelling.citSections.createCI',
              },
            ],
          },
        ],
      },
      {
        key: 'srm.import',
        title: 'import',
        children: [
          {
            key: ACCESS_RULES_TREE.srm.ci.import,
            title: 'srm.ci.label',
          },
          {
            key: ACCESS_RULES_TREE.srm.cit.import,
            title: 'srm.cit.label',
          },
          {
            key: ACCESS_RULES_TREE.srm.enrichment.import,
            title: 'srm.enrichment.label',
          },
        ],
      },
      {
        key: 'srm.export',
        title: 'export',
        children: [
          {
            key: ACCESS_RULES_TREE.srm.ci.export,
            title: 'srm.ci.label',
          },
          {
            key: ACCESS_RULES_TREE.srm.cit.export,
            title: 'srm.cit.label',
          },
          {
            key: ACCESS_RULES_TREE.srm.enrichment.export,
            title: 'srm.enrichment.label',
          },
        ],
      },
    ],
  },
  {
    key: 'monitoring',
    title: 'monitoring.label',
    children: [
      {
        key: 'monitoring.monitoring',
        title: 'monitoring.label',
        children: [
          {
            title: 'monitoring.templates.edit',
            key: ACCESS_RULES_TREE.monitoring.templates.edit,
          },
          {
            title: 'monitoring.hi.edit',
            key: ACCESS_RULES_TREE.monitoring.hi.edit,
          },
          {
            title: 'monitoring.prometheus.edit',
            key: ACCESS_RULES_TREE.monitoring.prometheus.edit,
          },
        ],
      },
      {
        key: 'monitoring.import',
        title: 'import',
        children: [
          {
            title: 'monitoring.hi.label',
            key: ACCESS_RULES_TREE.monitoring.hi.import,
          },
          {
            title: 'monitoring.templates.label',
            key: ACCESS_RULES_TREE.monitoring.templates.import,
          },
          {
            title: 'monitoring.prometheus.jobs.label',
            key: ACCESS_RULES_TREE.monitoring.prometheus.jobs.import,
          },
          {
            title: 'monitoring.prometheus.exporters.label',
            key: ACCESS_RULES_TREE.monitoring.prometheus.exporters.import,
          },
          {
            title: 'monitoring.vmagents.label',
            key: ACCESS_RULES_TREE.monitoring.vmagents.import,
          },
          {
            title: 'monitoring.vmalerts.label',
            key: ACCESS_RULES_TREE.monitoring.vmalerts.import,
          },
        ],
      },
      {
        key: 'monitoring.export',
        title: 'export',
        children: [
          {
            title: 'monitoring.hi.label',
            key: ACCESS_RULES_TREE.monitoring.hi.export,
          },
          {
            title: 'monitoring.templates.label',
            key: ACCESS_RULES_TREE.monitoring.templates.export,
          },
          {
            title: 'monitoring.prometheus.jobs.label',
            key: ACCESS_RULES_TREE.monitoring.prometheus.jobs.export,
          },
          {
            title: 'monitoring.prometheus.exporters.label',
            key: ACCESS_RULES_TREE.monitoring.prometheus.exporters.export,
          },
          {
            title: 'monitoring.vmagents.label',
            key: ACCESS_RULES_TREE.monitoring.vmagents.export,
          },
          {
            title: 'monitoring.vmalerts.label',
            key: ACCESS_RULES_TREE.monitoring.vmalerts.export,
          },
        ],
      },
    ],
  },
  {
    key: 'users',
    title: 'users.edit',
    children: [
      {
        key: ACCESS_RULES_TREE.users.attribute.edit,
        title: 'users.attribute.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.profile.edit,
        title: 'users.profile.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.profile.view,
        title: 'users.profile.view',
      },
      {
        key: ACCESS_RULES_TREE.users.status.edit,
        title: 'users.status.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.change_password.edit,
        title: 'users.change_password.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.ldap.edit,
        title: 'users.ldap.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.oidc.edit,
        title: 'users.oidc.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.delete.edit,
        title: 'users.delete.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.api_token.edit,
        title: 'users.api_token.edit',
      },
      {
        key: ACCESS_RULES_TREE.users.activity.log.view,
        title: 'users.activity.log',
      },
      {
        key: ACCESS_RULES_TREE.users.session.kill,
        title: 'users.session.kill',
      },
    ],
  },
  {
    key: 'access',
    title: 'access.label',

    children: [
      {
        key: ACCESS_RULES_TREE.access.srm.edit,
        title: 'access.srm.edit',
      },
      {
        key: ACCESS_RULES_TREE.srm.external.routes.get,
        title: 'srm.external.routes.get',
      },
      {
        key: ACCESS_RULES_TREE.access.monitoring.edit,
        title: 'access.monitoring.edit',
      },
      {
        key: ACCESS_RULES_TREE.access.dashboards.edit,
        title: 'access.dashboards.edit',
      },
      {
        key: ACCESS_RULES_TREE.access.func.edit,
        title: 'access.func.edit',
      },
      {
        key: ACCESS_RULES_TREE.access.tql.edit,
        title: 'access.tql.edit',
      },
    ],
  },
  {
    key: 'notifications',
    title: 'notifications.label',
    children: [
      {
        key: ACCESS_RULES_TREE.notifications.self.edit,
        title: 'notifications.self.edit',
        default: true,
      },
      {
        key: ACCESS_RULES_TREE.notifications.template.edit,
        title: 'notifications.template.edit',
      },
      {
        key: ACCESS_RULES_TREE.notifications.alertmanager.edit,
        title: 'notifications.alertmanager.edit',
      },
    ],
  },

  {
    key: 'system',
    title: 'system.label',

    children: [
      {
        key: 'system.docker',
        title: 'system.docker.label',
        children: [
          {
            key: ACCESS_RULES_TREE.system.docker.edit,
            title: 'system.docker.edit',
          },
          {
            key: ACCESS_RULES_TREE.system.docker.view,
            title: 'system.docker.view',
          },
          {
            key: ACCESS_RULES_TREE.system.docker.run,
            title: 'system.docker.run',
          },
        ],
      },
      {
        key: 'system.content-pack',
        title: 'system.content-pack.label',
        children: [
          {
            key: ACCESS_RULES_TREE.system.contentpack.import,
            title: 'system.content-pack.import',
          },
          {
            key: ACCESS_RULES_TREE.system.contentpack.create,
            title: 'system.content-pack.create',
          },
        ],
      },
      {
        key: ACCESS_RULES_TREE.system.plugins.edit,
        title: 'system.plugins.edit',
      },
      {
        key: 'system.settings',
        title: 'system.settings.label',
        children: [
          {
            key: 'system.settings.auth',
            title: 'system.settings.auth.label',
            children: [
              {
                key: ACCESS_RULES_TREE.system.settings.auth.view,
                title: 'system.settings.auth.view',
              },
              {
                key: ACCESS_RULES_TREE.system.settings.auth.edit,
                title: 'system.settings.auth.edit',
              },
            ],
          },
          {
            key: 'system.settings.srm',
            title: 'system.settings.srm.label',
            children: [
              {
                key: ACCESS_RULES_TREE.system.settings.srm.view,
                title: 'system.settings.srm.view',
              },
              {
                key: ACCESS_RULES_TREE.system.settings.srm.edit,
                title: 'system.settings.srm.edit',
              },
            ],
          },
          {
            key: 'system.settings.monitoring',
            title: 'system.settings.monitoring.label',
            children: [
              {
                key: ACCESS_RULES_TREE.system.settings.monitoring.view,
                title: 'system.settings.monitoring.view',
              },
              {
                key: ACCESS_RULES_TREE.system.settings.monitoring.edit,
                title: 'system.settings.monitoring.edit',
              },
            ],
          },
          {
            key: 'system.settings.notification',
            title: 'system.settings.notification.label',
            children: [
              {
                key: ACCESS_RULES_TREE.system.settings.notification.view,
                title: 'system.settings.notification.view',
              },
              {
                key: ACCESS_RULES_TREE.system.settings.notification.edit,
                title: 'system.settings.notification.edit',
              },
            ],
          },
          {
            key: 'system.settings.docker_tool',
            title: 'system.settings.docker_tool.label',
            children: [
              {
                key: ACCESS_RULES_TREE.system.settings['docker-tool'].view,
                title: 'system.settings.docker_tool.view',
              },
              {
                key: ACCESS_RULES_TREE.system.settings['docker-tool'].edit,
                title: 'system.settings.docker_tool.edit',
              },
            ],
          },
          {
            key: 'system.settings.task_tool',
            title: 'system.settings.task_tool.label',
            children: [
              {
                key: ACCESS_RULES_TREE.system.settings['task-tool'].view,
                title: 'system.settings.task_tool.view',
              },
              {
                key: ACCESS_RULES_TREE.system.settings['task-tool'].edit,
                title: 'system.settings.task_tool.edit',
              },
            ],
          },
        ],
      },
      // {
      //   key: ACCESS_RULES_TREE.system.settings.edit,
      //   title: 'settings.edit',
      // },
      {
        key: ACCESS_RULES_TREE.system.debug.edit,
        title: 'system.debug.edit',
      },
    ],
  },
  {
    key: ACCESS_RULES_TREE.license.edit,
    title: 'license.edit',
  },
  {
    key: 'third_party_service',
    title: 'third_party_service.label',
    children: [
      {
        key: ACCESS_RULES_TREE.third_party_service.os_dashboards.edit,
        title: 'third_party_service.os_dashboards',
      },
      {
        key: ACCESS_RULES_TREE.third_party_service.flower.edit,
        title: 'third_party_service.flower',
      },
      {
        key: ACCESS_RULES_TREE.third_party_service.alertmanager.edit,
        title: 'third_party_service.alertmanager',
      },
      {
        key: ACCESS_RULES_TREE.third_party_service.rabbitmq.edit,
        title: 'third_party_service.rabbitmq',
      },
      {
        key: ACCESS_RULES_TREE.third_party_service['metrics-agent'].edit,
        title: 'third_party_service.metrics_agent',
      },
      {
        key: ACCESS_RULES_TREE.third_party_service['metrics-storage'].edit,
        title: 'third_party_service.metrics_storage',
      },
      {
        key: ACCESS_RULES_TREE.third_party_service['metrics-ruler'].edit,
        title: 'third_party_service.metrics_ruler',
      },
    ],
  },
  //   {
  //     'key': 'changeRequest',
  //     'title': 'changeRequest',
  //   },

  //   {
  //     'key': 'settings.title',
  //     'title': 'settings.title',

  //     'children': [
  //       {
  //         'key': 'settings.srm',
  //         'title': 'settings.srm',

  //         'children': [
  //           {
  //             'key': 'settings.cit',
  //             'title': 'settings.cit',
  //           },
  //           {
  //             'key': 'settings.enrichment',
  //             'title': 'settings.enrichment',
  //           },
  //           {
  //             'key': 'settings.actionPlans',
  //             'title': 'settings.actionPlans',
  //           },
  //           {
  //             'key': 'settings.attributes',
  //             'title': 'settings.attributes',
  //           },
  //         ],
  //       },

  //       {
  //         'key': 'settings.monitoring',
  //         'title': 'settings.monitoring',

  //         'children': [
  //           {
  //             'key': 'settings.healthIndicators',
  //             'title': 'settings.healthIndicators',
  //           },
  //           {
  //             'key': 'settings.monitoringSettings',
  //             'title': 'settings.monitoringSettings',
  //           },
  //           {
  //             'key': 'settings.prometheus',
  //             'title': 'settings.prometheus',
  //           },
  //         ],
  //       },

  //       {
  //         'key': 'settings.users',
  //         'title': 'settings.users',

  //         'children': [
  //           {
  //             'key': 'settings.user',
  //             'title': 'settings.user',
  //           },
  //           {
  //             'key': 'settings.ldap',
  //             'title': 'settings.ldap',
  //           },
  //         ],
  //       },

  //       {
  //         'key': 'settings.system',
  //         'title': 'settings.system',

  //         'children': [
  //           {
  //             'key': 'settings.globalSettings',
  //             'title': 'settings.globalSettings',
  //           },
  //         ],
  //       },
  //     ],
  //   },
];
